import { render, staticRenderFns } from "./Bantuan.vue?vue&type=template&id=c4aeaca4&"
import script from "./Bantuan.vue?vue&type=script&lang=js&"
export * from "./Bantuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports